export default __webpack_public_path__ + "static/media/ea.7794d0bf.svg";